import API from '@/views/Fdc/Apis/'

/**
 * Preprocessing > Data Summary Plan
 * Data Summary Plan 관리
 */
export default {
  name: 'FdcDataSummaryPlan',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Data Summary Plan 조회
     */
    async getSummaryPlanList () {
      this.movePre()
      this.tabIdx = 0
      if (this.selectedTreeNode === null || this.selectedTreeNode.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return false
      }

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      let payload = {
        fab: this.selectedTreeNode.detail.fab,
        eqpId: this.selectedTreeNode.detail.eqpId,
        moduleId: this.selectedTreeNode.detail.moduleId,
        useYn: 'Y',
        recipeId: 'ALL'
      }
      let paramList = await API.BaseInfo.getEqpParams(payload)
      this.paramListRowData = paramList

      let stepList = await API.BaseInfo.getEqpRecipeSteps(payload)
      this.recipeStepListRowData = stepList

      let smryTypeList = await API.Common.getCodesMap({ codeType: 'smryType' })
      // var smryTypeArray = ['MIN', 'MAX', 'MEAN', 'MEDIAN', 'RANGE', 'STDEV', 'AREA', 'SLOPE', 'P05', 'P10', 'P25', 'P75', 'P90', 'P95']
      let descList = ['Minimum', 'Maximum', 'Arithmetic Mean', 'Median', 'Range', 'Standard Deviation', 'Area', 'Slop', '5% Percentile', '10% Percentile', '25% Percentile', '75% Percentile', '90% Percentile', '95% Percentile']
      for (var i = 0; i < smryTypeList.length; i++) {
        smryTypeList[i]['desc'] = descList[i]
      }
      this.smryTypeListRowData = smryTypeList

      let planedSmryParam = await API.Collection.getSummaryPlanParams(payload)
      let planedSmryRecipe = await API.Collection.getSummaryPlanRecipes(payload)
      let planedSmryType = await API.Collection.getSummaryPlanTypes(payload)

      // this.setGridAllCheck(this.$refs.paramGrid, 'param', planedSmryParam)
      // let planedSmryParam = []
      // let planedSmryRecipe = []
      // let planedSmryType = []
      // 저장된 Plan이 없을시 모든 값을 선택 한다.
      if (planedSmryParam.length === 0) {
        if (this.$refs.paramGrid !== undefined && this.$refs.paramGrid !== null) {
          this.setGridAllCheck(this.$refs.paramGrid, 'param', planedSmryParam)
        }
        if (this.$refs.recipeStepGrid !== undefined && this.$refs.recipeStepGrid !== null) {
          this.setGridAllCheck(this.$refs.recipeStepGrid, 'recipe', planedSmryRecipe)
        }
        if (this.$refs.smryTypeGrid !== undefined && this.$refs.smryTypeGrid !== null) {
          this.setGridAllCheck(this.$refs.smryTypeGrid, 'type', planedSmryType)
        }
      } else {
        this.setGridAllCheck(this.$refs.paramGrid, 'param', planedSmryParam)
        this.setGridAllCheck(this.$refs.recipeStepGrid, 'recipe', planedSmryRecipe)
        this.setGridAllCheck(this.$refs.smryTypeGrid, 'type', planedSmryType)
      }
    },
    /**
     * Grid row data all check
     * @param {*} gridType brique grid
     * @param {String} colStr column string
     * @param {Array} planList grid row data 배열
     */
    setGridAllCheck (gridType, colStr, planList) {
      // const rows = gridType.grid.rows

      // for (let i = 0; i < rows.length; i++) {
      //   let params = []
      //   switch (colStr) {
      //     case 'param':
      //       params.push(rows[i].dataItem.paramName)
      //       break
      //     case 'type':
      //       params.push(rows[i].dataItem.code)
      //       break
      //     default:
      //       params.push(rows[i].dataItem.recipeId)
      //       params.push(rows[i].dataItem.stepId)
      //       break
      //   }
      //   var index = this.planListIndexOf(colStr, planList, params)
      //   if (index < 0 && planList.length > 0) continue
      //   if (index > -1) {
      //     gridType.grid.deferUpdate(() => {
      //       if (colStr === 'recipe') {
      //         rows[i].dataItem.settlingTime = planList[index].settlingTime
      //         rows[i].dataItem.activationTime = planList[index].activationTime
      //       }
      //       rows[i].dataItem._status.checked = true
      //     })
      //   }
      // }

      gridType.gridApi.forEachNode(node => {
        let params = []
        switch (colStr) {
          case 'param':
            params.push(node.data.paramName)
            break
          case 'type':
            params.push(node.data.code)
            break
          default:
            params.push(node.data.recipeId)
            params.push(node.data.stepId)
            break
        }

        var index = this.planListIndexOf(colStr, planList, params)
        if (index < 0 && planList.length > 0) return
        if (index > -1) {
          const rows = gridType.getAllRows()
          rows.forEach(row => {
            if (colStr === 'recipe') {
              node.data.settlingTime = planList[index].settlingTime
              node.data.activationTime = planList[index].activationTime
            }
            node.setSelected(true)
          })
        }
      })
    },
    /**
     * row index 검색
     * @param {String} colType column string
     * @param {Array} planList row data
     * @param {Array} conditions index 검색 조건
     * @returns {Number} row index
     */
    planListIndexOf (colType, planList, conditions) {
      var containIndex = -1
      planList.some((item, idx) => {
        var flag
        switch (colType) {
          case 'param':
            flag = item.paramName === conditions[0]
            break
          case 'type':
            flag = item.smryType === conditions[0]
            break
          default:
            flag = item.recipeId === conditions[0] && item.stepId === conditions[1]
            break
        }
        if (flag) {
          containIndex = idx
        }
        return flag
      })
      return containIndex
    },
    /**
     * Next button click
     */
    moveNext () {
      this.$el.getElementsByClassName('tab-item')[0].style.display = 'none'
      this.$el.getElementsByClassName('tab-item')[1].style.display = 'block'
      this.$el.getElementsByClassName('tabs')[0].childNodes[0].children[0].setAttribute('class', '')
      this.$el.getElementsByClassName('tabs')[0].childNodes[0].children[1].setAttribute('class', 'is-active')

      let resultData = []
      let paramCheckedData = this.$refs.paramGrid.getCheckedRows() // this.$refs.paramGrid.checkedRows
      let recipeStepCheckedData = this.$refs.recipeStepGrid.getCheckedRows() // this.$refs.recipeStepGrid.checkedRows
      let smryTypeCheckedData = this.$refs.smryTypeGrid.getCheckedRows() // this.$refs.smryTypeGrid.checkedRows

      paramCheckedData.forEach((param) => {
        recipeStepCheckedData.forEach((recipeStep) => {
          let obj = {
            aliasName: param.aliasName,
            paramName: param.paramName,
            recipe: recipeStep.recipeId,
            step: recipeStep.stepId,
            settlingTime: recipeStep.startSettlingTime,
            activationTime: recipeStep.activationTime,
            lotStepYn: 'N'
          }
          this.smryTypeListRowData.forEach((data) => {
            smryTypeCheckedData.some((smryType) => {
              if (data.code === smryType.code) {
                obj[data.code] = true
              } else {
                obj[data.code] = false
              }
              return (data.code === smryType.code)
            })
          })
          resultData.push(obj)
        })

        // this.smryTypeList
        // smryTypeCheckedData.forEach((smryType) => {
        //   resultData[]
        // })
      })
      this.resultListRowData = resultData
    },
    /**
     * Previous button click
     */
    movePre () {
      this.$el.getElementsByClassName('tab-item')[0].style.display = 'block'
      this.$el.getElementsByClassName('tab-item')[1].style.display = 'none'
      this.$el.getElementsByClassName('tabs')[0].childNodes[0].children[0].setAttribute('class', 'is-active')
      this.$el.getElementsByClassName('tabs')[0].childNodes[0].children[1].setAttribute('class', '')
    },
    /**
     * tab click
     * @param {Number} idx tab index
     */
    move (idx) {
      this.tabIdx = idx
    },
    /**
     * Data Summary Plan 저장
     */
    saveSummaryDataPlan () {
      const saveSummaryPlan = async () => {
        let checkedRows = this.$refs.resultGrid.getCheckedRows() // this.$refs.resultGrid.checkedRows
        let insertPlanData = []
        if (checkedRows.length === 0) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return false
        }

        checkedRows.forEach((item) => {
          let smryTypeMap = {}
          this.smryTypeListRowData.forEach((data) => {
            smryTypeMap[data.code] = item[data.code]
          })

          let planData = {
            fab: this.selectedTreeNode.detail.fab,
            eqpId: this.selectedTreeNode.detail.eqpId,
            moduleId: this.selectedTreeNode.detail.moduleId,
            paramName: item.paramName,
            recipeId: item.recipe,
            stepId: item.step,
            smryTypeMap: smryTypeMap,
            lotStepYn: item.lotStepYn,
            settlingTime: item.settlingTime,
            activationTime: item.activationTime
          }
          insertPlanData.push(planData)
        })
        await API.Collection.saveSummaryPlan(insertPlanData).then(result => {
          if (result != null && result.status === 200) {
            this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
          }
        })
      }
      this.$dialog.confirm({
        message: this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: saveSummaryPlan,
        onCancel: function () {}
      })
    },
    /**
     * Tab change event
     * @param {Number} idx tab index
     */
    onTabsChanged (idx) {
      switch (idx) {
        case 0:
          this.movePre()
          break
        case 1:
          this.moveNext()
          break
      }
    }
  },
  data () {
    return {
      selectedTreeNode: null, // 선택된 EQP Tree node
      paramListRowData: [], // Parameter List row data
      paramListGrid: [], // Parameter List grid
      paramListColumns: [
        // { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '1*', readOnly: true },
        // { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', width: '1*', readOnly: true, allowMerging: true, visible: false }
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: '1', editable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', flex: '1', allowMerging: true, hide: true }
      ], // Parameter List grid column 배열
      recipeStepListRowData: [], // Recipe List row data
      recipeStepListGrid: [], // Recipe List grid
      recipeStepListColumns: [
        // { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: '1*', readOnly: true },
        // { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'stepId', width: '1*', readOnly: true },
        // { label: this.$t('fdc.COMMON.COLUMN.SETTLING_TIME'), binding: 'settlingTime', width: '1*', readOnly: false, required: true },
        // { label: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), binding: 'activationTime', width: '1*', readOnly: false, required: true }
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', flex: '2', editable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', flex: '1', editable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.SETTLING_TIME'), field: 'settlingTime', flex: '1', editable: true, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), field: 'activationTime', flex: '1', editable: true, required: true }
      ], // Recipe List grid column 배열
      smryTypeListRowData: [], // Summary Type List row data
      smryTypeListGrid: [], // Summary Type List grid
      smryTypeListColumns: [
        // { label: this.$t('fdc.COMMON.COLUMN.TYPE'), binding: 'code', width: '1*', readOnly: true },
        // { label: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), binding: 'desc', width: '1*', readOnly: true }
        { headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'code', flex: '1', editable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'desc', flex: '1', editable: false }
      ], // Summary Type List grid column 배열
      resultListRowData: [], // Summary Plan List row data
      resultListGrid: [], // Summary Plan List grid
      resultListColumns: [ // TODO: row group
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: '1', minWidth: 250, maxWidth: 250, editable: false, checkboxSelection: true, headerCheckboxSelection: true }, // allowMerging: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', flex: '1', minWidth: 100, maxWidth: 100, editable: false, hide: true }, // allowMerging: true, visible: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipe', flex: '1', minWidth: 100, maxWidth: 100, editable: false }, // allowMerging: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'step', flex: '1', minWidth: 50, maxWidth: 50, editable: false }, // allowMerging: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.SETTLING_TIME'), field: 'settlingTime', flex: '1', minWidth: 150, maxWidth: 150, editable: true, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), field: 'activationTime', flex: '1', minWidth: 150, maxWidth: 150, editable: true, required: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_STEP_YN'), field: 'lotStepYn', dataMap: ['Y', 'N'], flex: '1', minWidth: 150, maxWidth: 150, editable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MIN'), field: 'MIN', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MAX'), field: 'MAX', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MEAN'), field: 'MEAN', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MEDIAN'), field: 'MEDIAN', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.RANGE'), field: 'RANGE', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.STDEV'), field: 'STDEV', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.AREA'), field: 'AREA', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOPE'), field: 'SLOPE', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P05'), field: 'P05', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P10'), field: 'P10', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P25'), field: 'P25', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P75'), field: 'P75', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P90'), field: 'P90', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.P95'), field: 'P95', flex: '1', minWidth: 80, maxWidth: 80, editable: true, type: 'checkboxColumn' }
        // { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '1*', minWidth: 250, maxWidth: 250, readOnly: true, allowMerging: true },
        // { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', width: '1*', minWidth: 100, maxWidth: 100, readOnly: true, allowMerging: true, visible: false },
        // { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipe', width: '1*', minWidth: 100, maxWidth: 100, readOnly: true, allowMerging: true },
        // { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'step', width: '1*', minWidth: 50, maxWidth: 50, readOnly: true, allowMerging: true },
        // { label: this.$t('fdc.COMMON.COLUMN.SETTLING_TIME'), binding: 'settlingTime', width: '1*', minWidth: 150, maxWidth: 150, readOnly: false, required: true },
        // { label: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), binding: 'activationTime', width: '1*', minWidth: 150, maxWidth: 150, readOnly: false, required: true },
        // { label: this.$t('fdc.COMMON.COLUMN.LOT_STEP_YN'), binding: 'lotStepYn', dataMap: ['Y', 'N'], width: '1*', minWidth: 150, maxWidth: 150, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.MIN'), binding: 'MIN', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.MAX'), binding: 'MAX', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.MEAN'), binding: 'MEAN', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.MEDIAN'), binding: 'MEDIAN', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.RANGE'), binding: 'RANGE', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.STDEV'), binding: 'STDEV', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.AREA'), binding: 'AREA', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.SLOPE'), binding: 'SLOPE', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P05'), binding: 'P05', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P10'), binding: 'P10', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P25'), binding: 'P25', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P75'), binding: 'P75', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P90'), binding: 'P90', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false },
        // { label: this.$t('fdc.COMMON.COLUMN.P95'), binding: 'P95', dataMap: [true, false], width: '1*', minWidth: 80, maxWidth: 80, readOnly: false }
      ], // Summary Plan List grid column 배열
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // collectionViewOptions: {
      //   groupDescriptions: ['aliasName']
      // }, // Summary Plan grid collectionView Option
      tabIdx: 0 // tab index
    }
  }
}
